import useSwrNoCache from '@/script/useSwrNoCache.mjs'
import {apiBaseConfig} from './apiBaseConfig.mjs'

export const useBaseConfig = () => {
    return useSwrNoCache(
        () => apiBaseConfig.read(),
    )
}
